import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import s from '../index.module.less';

type PropsType = {
  incrementButton: any;
  decrementButton: any;
  disabled?: boolean;
};

const MediumQuantityButton = ({ incrementButton, decrementButton, disabled }: PropsType) => (
  <div className={s.btnContainer}>
    <Button
      size="small"
      type="text"
      className={s.adjustmentBtn}
      icon={<CaretUpOutlined />}
      {...incrementButton}
      disabled={disabled}
      data-test="increase"
    />
    <Button
      size="small"
      type="text"
      className={s.adjustmentBtn}
      icon={<CaretDownOutlined />}
      {...decrementButton}
      disabled={disabled}
      data-test="decrease"
    />
  </div>
);

export default MediumQuantityButton;
